import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_AC_SPLIT_TYPE',
  GET: 'GET_AC_SPLIT_TYPE',
  CREATE: 'CREATE_AC_SPLIT_TYPE',
  EDIT: 'EDIT_AC_SPLIT_TYPE',
  DELETE: 'DELETE_AC_SPLIT_TYPE',
  DUPLICATE: 'DUPLICATE_AC_SPLIT_TYPE',
  CLEAR_ERROR: 'CLEAR_ERROR_AC_SPLIT_TYPE',
};

export const clearErrorACSplit = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchACSplitTypeByText = (text, page = 0, excludeZoneId = null) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchACSplitType(pageSize, page, sorted, filtered, isPublic, excludeZoneId);
};

const searchACSplitType = (pageSize, page, sorted, filtered, isPublic, excludeZoneId = null) => {
  const zoneParams = excludeZoneId && { not__zone_id: excludeZoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_AC_SPLIT_TYPE,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => (sort.desc ? `-${sort.id}` : sort.id)).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listACSplitType = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchACSplitType(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const getACSpiltType = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_AC_SPLIT_TYPE}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const createACSpiltType = (name, typeId, brandId, SEER, coolingCap, unitId, powerRequired, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('type', typeId);
  formData.set('brand_id', brandId);
  formData.set('SEER', SEER);
  formData.set('cooling_capacity', coolingCap);
  formData.set('unit', unitId);
  formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `acst_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_AC_SPLIT_TYPE,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editACSpiltType = (id, name, typeId, brandId, SEER, coolingCap, unitId, powerRequired, description, image, cfpValue, cfpUnit) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (typeId) formData.set('type', typeId);
  if (brandId) formData.set('brand_id', brandId);
  if (SEER) formData.set('SEER', SEER);
  if (coolingCap) formData.set('cooling_capacity', coolingCap);
  if (unitId) formData.set('unit', unitId);
  if (powerRequired) formData.set('power_required', powerRequired);
  if (typeof description === 'string') formData.set('description', description);
  if (cfpValue !== undefined && cfpValue !== null && cfpValue !== '') formData.set('cfp_value', cfpValue);
  if (cfpUnit) formData.set('cfp_unit', cfpUnit);
  if (image) formData.set('image', image, `acst_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_AC_SPLIT_TYPE}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteACSplitType = id => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_AC_SPLIT_TYPE}${id}/`,
    })
      .then(() => ({ id }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateACSplitType = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_AC_SPLIT_TYPE}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/ac_split_type/ac_split_type_actions.js